"use client"

import { BetweenHorizontalStart } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BetweenHorizontalStartIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BetweenHorizontalStartIcon = component(Icon)({
  as: BetweenHorizontalStart,
})
